export default [
  {
    value: 'EUR',
    name: 'Euro',
    id: 'Euro'
  },
  {
    value: 'AED',
    name: 'United Arab Emirates Dirham',
    id: 'United Arab Emirates Dirham'
  },
  {
    value: 'AFN',
    name: 'Afghan Afghani',
    id: 'Afghan Afghani'
  },
  {
    value: 'ALL',
    name: 'Albanian Lek',
    id: 'Albanian Lek'
  },
  {
    value: 'AMD',
    name: 'Armenian Dram',
    id: 'Armenian Dram'
  },
  {
    value: 'ANG',
    name: 'Netherlands Antillean Guilder',
    id: 'Netherlands Antillean Guilder'
  },
  {
    value: 'AOA',
    name: 'Angolan Kwanza',
    id: 'Angolan Kwanza'
  },
  {
    value: 'ARS',
    name: 'Argentine Peso',
    id: 'Argentine Peso'
  },
  {
    value: 'AUD',
    name: 'Australian Dollar',
    id: 'Australian Dollar'
  },
  {
    value: 'AWG',
    name: 'Aruban Florin',
    id: 'Aruban Florin'
  },
  {
    value: 'AZN',
    name: 'Azerbaijani Manat',
    id: 'Azerbaijani Manat'
  },
  {
    value: 'BAM',
    name: 'Bosnia-Herzegovina Convertible Mark',
    id: 'Bosnia-Herzegovina Convertible Mark'
  },
  {
    value: 'BBD',
    name: 'Barbadian Dollar',
    id: 'Barbadian Dollar'
  },
  {
    value: 'BDT',
    name: 'Bangladeshi Taka',
    id: 'Bangladeshi Taka'
  },
  {
    value: 'BGN',
    name: 'Bulgarian Lev',
    id: 'Bulgarian Lev'
  },
  {
    value: 'BHD',
    name: 'Bahraini Dinar',
    id: 'Bahraini Dinar'
  },
  {
    value: 'BIF',
    name: 'Burundian Franc',
    id: 'Burundian Franc'
  },
  {
    value: 'BMD',
    name: 'Bermudan Dollar',
    id: 'Bermudan Dollar'
  },
  {
    value: 'BND',
    name: 'Brunei Dollar',
    id: 'Brunei Dollar'
  },
  {
    value: 'BOB',
    name: 'Bolivian Boliviano',
    id: 'Bolivian Boliviano'
  },
  {
    value: 'BRL',
    name: 'Brazilian Real',
    id: 'Brazilian Real'
  },
  {
    value: 'BSD',
    name: 'Bahamian Dollar',
    id: 'Bahamian Dollar'
  },
  {
    value: 'BTC',
    name: 'Bitcoin',
    id: 'Bitcoin'
  },
  {
    value: 'BTN',
    name: 'Bhutanese Ngultrum',
    id: 'Bhutanese Ngultrum'
  },
  {
    value: 'BWP',
    name: 'Botswanan Pula',
    id: 'Botswanan Pula'
  },
  {
    value: 'BYN',
    name: 'Belarusian Ruble',
    id: 'Belarusian Ruble'
  },
  {
    value: 'BZD',
    name: 'Belize Dollar',
    id: 'Belize Dollar'
  },
  {
    value: 'CAD',
    name: 'Canadian Dollar',
    id: 'Canadian Dollar'
  },
  {
    value: 'CDF',
    name: 'Congolese Franc',
    id: 'Congolese Franc'
  },
  {
    value: 'CHF',
    name: 'Swiss Franc',
    id: 'Swiss Franc'
  },
  {
    value: 'CLF',
    name: 'Chilean Unit of Account (UF)',
    id: 'Chilean Unit of Account (UF)'
  },
  {
    value: 'CLP',
    name: 'Chilean Peso',
    id: 'Chilean Peso'
  },
  {
    value: 'CNH',
    name: 'Chinese Yuan (Offshore)',
    id: 'Chinese Yuan (Offshore)'
  },
  {
    value: 'CNY',
    name: 'Chinese Yuan',
    id: 'Chinese Yuan'
  },
  {
    value: 'COP',
    name: 'Colombian Peso',
    id: 'Colombian Peso'
  },
  {
    value: 'CRC',
    name: 'Costa Rican Colón',
    id: 'Costa Rican Colón'
  },
  {
    value: 'CUC',
    name: 'Cuban Convertible Peso',
    id: 'Cuban Convertible Peso'
  },
  {
    value: 'CUP',
    name: 'Cuban Peso',
    id: 'Cuban Peso'
  },
  {
    value: 'CVE',
    name: 'Cape Verdean Escudo',
    id: 'Cape Verdean Escudo'
  },
  {
    value: 'CZK',
    name: 'Czech Republic Koruna',
    id: 'Czech Republic Koruna'
  },
  {
    value: 'DJF',
    name: 'Djiboutian Franc',
    id: 'Djiboutian Franc'
  },
  {
    value: 'DKK',
    name: 'Danish Krone',
    id: 'Danish Krone'
  },
  {
    value: 'DOP',
    name: 'Dominican Peso',
    id: 'Dominican Peso'
  },
  {
    value: 'DZD',
    name: 'Algerian Dinar',
    id: 'Algerian Dinar'
  },
  {
    value: 'EGP',
    name: 'Egyptian Pound',
    id: 'Egyptian Pound'
  },
  {
    value: 'ERN',
    name: 'Eritrean Nakfa',
    id: 'Eritrean Nakfa'
  },
  {
    value: 'ETB',
    name: 'Ethiopian Birr',
    id: 'Ethiopian Birr'
  },
  {
    value: 'EUR',
    name: 'Euro',
    id: 'Euro2'
  },
  {
    value: 'FJD',
    name: 'Fijian Dollar',
    id: 'Fijian Dollar'
  },
  {
    value: 'FKP',
    name: 'Falkland Islands Pound',
    id: 'Falkland Islands Pound'
  },
  {
    value: 'GBP',
    name: 'British Pound Sterling',
    id: 'British Pound Sterling'
  },
  {
    value: 'GEL',
    name: 'Georgian Lari',
    id: 'Georgian Lari'
  },
  {
    value: 'GGP',
    name: 'Guernsey Pound',
    id: 'Guernsey Pound'
  },
  {
    value: 'GHS',
    name: 'Ghanaian Cedi',
    id: 'Ghanaian Cedi'
  },
  {
    value: 'GIP',
    name: 'Gibraltar Pound',
    id: 'Gibraltar Pound'
  },
  {
    value: 'GMD',
    name: 'Gambian Dalasi',
    id: 'Gambian Dalasi'
  },
  {
    value: 'GNF',
    name: 'Guinean Franc',
    id: 'Guinean Franc'
  },
  {
    value: 'GTQ',
    name: 'Guatemalan Quetzal',
    id: 'Guatemalan Quetzal'
  },
  {
    value: 'GYD',
    name: 'Guyanaese Dollar',
    id: 'Guyanaese Dollar'
  },
  {
    value: 'HKD',
    name: 'Hong Kong Dollar',
    id: 'Hong Kong Dollar'
  },
  {
    value: 'HNL',
    name: 'Honduran Lempira',
    id: 'Honduran Lempira'
  },
  {
    value: 'HRK',
    name: 'Croatian Kuna',
    id: 'Croatian Kuna'
  },
  {
    value: 'HTG',
    name: 'Haitian Gourde',
    id: 'Haitian Gourde'
  },
  {
    value: 'HUF',
    name: 'Hungarian Forint',
    id: 'Hungarian Forint'
  },
  {
    value: 'IDR',
    name: 'Indonesian Rupiah',
    id: 'Indonesian Rupiah'
  },
  {
    value: 'ILS',
    name: 'Israeli New Sheqel',
    id: 'Israeli New Sheqel'
  },
  {
    value: 'IMP',
    name: 'Manx pound',
    id: 'Manx pound'
  },
  {
    value: 'INR',
    name: 'Indian Rupee',
    id: 'Indian Rupee'
  },
  {
    value: 'IQD',
    name: 'Iraqi Dinar',
    id: 'Iraqi Dinar'
  },
  {
    value: 'IRR',
    name: 'Iranian Rial',
    id: 'Iranian Rial'
  },
  {
    value: 'ISK',
    name: 'Icelandic Króna',
    id: 'Icelandic Króna'
  },
  {
    value: 'JEP',
    name: 'Jersey Pound',
    id: 'Jersey Pound'
  },
  {
    value: 'JMD',
    name: 'Jamaican Dollar',
    id: 'Jamaican Dollar'
  },
  {
    value: 'JOD',
    name: 'Jordanian Dinar',
    id: 'Jordanian Dinar'
  },
  {
    value: 'JPY',
    name: 'Japanese Yen',
    id: 'Japanese Yen'
  },
  {
    value: 'KES',
    name: 'Kenyan Shilling',
    id: 'Kenyan Shilling'
  },
  {
    value: 'KGS',
    name: 'Kyrgystani Som',
    id: 'Kyrgystani Som'
  },
  {
    value: 'KHR',
    name: 'Cambodian Riel',
    id: 'Cambodian Riel'
  },
  {
    value: 'KMF',
    name: 'Comorian Franc',
    id: 'Comorian Franc'
  },
  {
    value: 'KPW',
    name: 'North Korean Won',
    id: 'North Korean Won'
  },
  {
    value: 'KRW',
    name: 'South Korean Won',
    id: 'South Korean Won'
  },
  {
    value: 'KWD',
    name: 'Kuwaiti Dinar',
    id: 'Kuwaiti Dinar'
  },
  {
    value: 'KYD',
    name: 'Cayman Islands Dollar',
    id: 'Cayman Islands Dollar'
  },
  {
    value: 'KZT',
    name: 'Kazakhstani Tenge',
    id: 'Kazakhstani Tenge'
  },
  {
    value: 'LAK',
    name: 'Laotian Kip',
    id: 'Laotian Kip'
  },
  {
    value: 'LBP',
    name: 'Lebanese Pound',
    id: 'Lebanese Pound'
  },
  {
    value: 'LKR',
    name: 'Sri Lankan Rupee',
    id: 'Sri Lankan Rupee'
  },
  {
    value: 'LRD',
    name: 'Liberian Dollar',
    id: 'Liberian Dollar'
  },
  {
    value: 'LSL',
    name: 'Lesotho Loti',
    id: 'Lesotho Loti'
  },
  {
    value: 'LYD',
    name: 'Libyan Dinar',
    id: 'Libyan Dinar'
  },
  {
    value: 'MAD',
    name: 'Moroccan Dirham',
    id: 'Moroccan Dirham'
  },
  {
    value: 'MDL',
    name: 'Moldovan Leu',
    id: 'Moldovan Leu'
  },
  {
    value: 'MGA',
    name: 'Malagasy Ariary',
    id: 'Malagasy Ariary'
  },
  {
    value: 'MKD',
    name: 'Macedonian Denar',
    id: 'Macedonian Denar'
  },
  {
    value: 'MMK',
    name: 'Myanma Kyat',
    id: 'Myanma Kyat'
  },
  {
    value: 'MNT',
    name: 'Mongolian Tugrik',
    id: 'Mongolian Tugrik'
  },
  {
    value: 'MOP',
    name: 'Macanese Pataca',
    id: 'Macanese Pataca'
  },
  {
    value: 'MRO',
    name: 'Mauritanian Ouguiya',
    id: 'Mauritanian Ouguiya'
  },
  {
    value: 'MUR',
    name: 'Mauritian Rupee',
    id: 'Mauritian Rupee'
  },
  {
    value: 'MVR',
    name: 'Maldivian Rufiyaa',
    id: 'Maldivian Rufiyaa'
  },
  {
    value: 'MWK',
    name: 'Malawian Kwacha',
    id: 'Malawian Kwacha'
  },
  {
    value: 'MXN',
    name: 'Mexican Peso',
    id: 'Mexican Peso'
  },
  {
    value: 'MYR',
    name: 'Malaysian Ringgit',
    id: 'Malaysian Ringgit'
  },
  {
    value: 'MZN',
    name: 'Mozambican Metical',
    id: 'Mozambican Metical'
  },
  {
    value: 'NAD',
    name: 'Namibian Dollar',
    id: 'Namibian Dollar'
  },
  {
    value: 'NGN',
    name: 'Nigerian Naira',
    id: 'Nigerian Naira'
  },
  {
    value: 'NIO',
    name: 'Nicaraguan Córdoba',
    id: 'Nicaraguan Córdoba'
  },
  {
    value: 'NOK',
    name: 'Norwegian Krone',
    id: 'Norwegian Krone'
  },
  {
    value: 'NPR',
    name: 'Nepalese Rupee',
    id: 'Nepalese Rupee'
  },
  {
    value: 'NZD',
    name: 'New Zealand Dollar',
    id: 'New Zealand Dollar'
  },
  {
    value: 'OMR',
    name: 'Omani Rial',
    id: 'Omani Rial'
  },
  {
    value: 'PAB',
    name: 'Panamanian Balboa',
    id: 'Panamanian Balboa'
  },
  {
    value: 'PEN',
    name: 'Peruvian Nuevo Sol',
    id: 'Peruvian Nuevo Sol'
  },
  {
    value: 'PGK',
    name: 'Papua New Guinean Kina',
    id: 'Papua New Guinean Kina'
  },
  {
    value: 'PHP',
    name: 'Philippine Peso',
    id: 'Philippine Peso'
  },
  {
    value: 'PKR',
    name: 'Pakistani Rupee',
    id: 'Pakistani Rupee'
  },
  {
    value: 'PLN',
    name: 'Polish Zloty',
    id: 'Polish Zloty'
  },
  {
    value: 'PYG',
    name: 'Paraguayan Guarani',
    id: 'Paraguayan Guarani'
  },
  {
    value: 'QAR',
    name: 'Qatari Rial',
    id: 'Qatari Rial'
  },
  {
    value: 'RON',
    name: 'Romanian Leu',
    id: 'Romanian Leu'
  },
  {
    value: 'RSD',
    name: 'Serbian Dinar',
    id: 'Serbian Dinar'
  },
  {
    value: 'RUB',
    name: 'Russian Ruble',
    id: 'Russian Ruble'
  },
  {
    value: 'RWF',
    name: 'Rwandan Franc',
    id: 'Rwandan Franc'
  },
  {
    value: 'SAR',
    name: 'Saudi Riyal',
    id: 'Saudi Riyal'
  },
  {
    value: 'SBD',
    name: 'Solomon Islands Dollar',
    id: 'Solomon Islands Dollar'
  },
  {
    value: 'SCR',
    name: 'Seychellois Rupee',
    id: 'Seychellois Rupee'
  },
  {
    value: 'SDG',
    name: 'Sudanese Pound',
    id: 'Sudanese Pound'
  },
  {
    value: 'SEK',
    name: 'Swedish Krona',
    id: 'Swedish Krona'
  },
  {
    value: 'SGD',
    name: 'Singapore Dollar',
    id: 'Singapore Dollar'
  },
  {
    value: 'SHP',
    name: 'Saint Helena Pound',
    id: 'Saint Helena Pound'
  },
  {
    value: 'SLL',
    name: 'Sierra Leonean Leone',
    id: 'Sierra Leonean Leone'
  },
  {
    value: 'SOS',
    name: 'Somali Shilling',
    id: 'Somali Shilling'
  },
  {
    value: 'SRD',
    name: 'Surinamese Dollar',
    id: 'Surinamese Dollar'
  },
  {
    value: 'SSP',
    name: 'South Sudanese Pound',
    id: 'South Sudanese Pound'
  },
  {
    value: 'STD',
    name: 'São Tomé and Príncipe Dobra',
    id: 'São Tomé and Príncipe Dobra'
  },
  {
    value: 'SVC',
    name: 'Salvadoran Colón',
    id: 'Salvadoran Colón'
  },
  {
    value: 'SYP',
    name: 'Syrian Pound',
    id: 'Syrian Pound'
  },
  {
    value: 'SZL',
    name: 'Swazi Lilangeni',
    id: 'Swazi Lilangeni'
  },
  {
    value: 'THB',
    name: 'Thai Baht',
    id: 'Thai Baht'
  },
  {
    value: 'TJS',
    name: 'Tajikistani Somoni',
    id: 'Tajikistani Somoni'
  },
  {
    value: 'TMT',
    name: 'Turkmenistani Manat',
    id: 'Turkmenistani Manat'
  },
  {
    value: 'TND',
    name: 'Tunisian Dinar',
    id: 'Tunisian Dinar'
  },
  {
    value: 'TOP',
    name: 'Tongan Paanga',
    id: 'Tongan Paanga'
  },
  {
    value: 'TRY',
    name: 'Turkish Lira',
    id: 'Turkish Lira'
  },
  {
    value: 'TTD',
    name: 'Trinidad and Tobago Dollar',
    id: 'Trinidad and Tobago Dollar'
  },
  {
    value: 'TWD',
    name: 'New Taiwan Dollar',
    id: 'New Taiwan Dollar'
  },
  {
    value: 'TZS',
    name: 'Tanzanian Shilling',
    id: 'Tanzanian Shilling'
  },
  {
    value: 'UAH',
    name: 'Ukrainian Hryvnia',
    id: 'Ukrainian Hryvnia'
  },
  {
    value: 'UGX',
    name: 'Ugandan Shilling',
    id: 'Ugandan Shilling'
  },
  {
    value: 'USD',
    name: 'United States Dollar',
    id: 'United States Dollar'
  },
  {
    value: 'UYU',
    name: 'Uruguayan Peso',
    id: 'Uruguayan Peso'
  },
  {
    value: 'UZS',
    name: 'Uzbekistan Som',
    id: 'Uzbekistan Som'
  },
  {
    value: 'VEF',
    name: 'Venezuelan Bolívar Fuerte',
    id: 'Venezuelan Bolívar Fuerte'
  },
  {
    value: 'VND',
    name: 'Vietnamese Dong',
    id: 'Vietnamese Dong'
  },
  {
    value: 'VUV',
    name: 'Vanuatu Vatu',
    id: 'Vanuatu Vatu'
  },
  {
    value: 'WST',
    name: 'Samoan Tala',
    id: 'Samoan Tala'
  },
  {
    value: 'XAF',
    name: 'CFA Franc BEAC',
    id: 'CFA Franc BEAC'
  },
  {
    value: 'XAG',
    name: 'Silver Ounce',
    id: 'Silver Ounce'
  },
  {
    value: 'XAU',
    name: 'Gold Ounce',
    id: 'Gold Ounce'
  },
  {
    value: 'XCD',
    name: 'East Caribbean Dollar',
    id: 'East Caribbean Dollar'
  },
  {
    value: 'XDR',
    name: 'Special Drawing Rights',
    id: 'Special Drawing Rights'
  },
  {
    value: 'XOF',
    name: 'CFA Franc BCEAO',
    id: 'CFA Franc BCEAO'
  },
  {
    value: 'XPD',
    name: 'Palladium Ounce',
    id: 'Palladium Ounce'
  },
  {
    value: 'XPF',
    name: 'CFP Franc',
    id: 'CFP Franc'
  },
  {
    value: 'XPT',
    name: 'Platinum Ounce',
    id: 'Platinum Ounce'
  },
  {
    value: 'YER',
    name: 'Yemeni Rial',
    id: 'Yemeni Rial'
  },
  {
    value: 'ZAR',
    name: 'South African Rand',
    id: 'South African Rand'
  },
  {
    value: 'ZMW',
    name: 'Zambian Kwacha',
    id: 'Zambian Kwacha'
  },
  {
    value: 'ZWL',
    name: 'Zimbabwean Dollar',
    id: 'Zimbabwean Dollar'
  }
];
